import Home from '@/views/Home.vue'
import Login from '@/views/Login.vue'
import Contact from '@/views/Contact'
import Dientsten from '@/views/diensten/Diensten'
import MedicalTaping from '@/views/diensten/MedicalTaping'
import SportMassage from '@/views/diensten/SportMassage'
import OntspanningsMassage from '@/views/diensten/OntspanningsMassage'
import OverMij from '@/views/OverMij'
import Tarieven from '@/views/Tarieven'
import Nieuws from '@/views/Nieuws'
import Logout from '@/components/Logout'
import NotFound from '@/views/NotFound'

export default [
    {
        path: '/',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/beheer',
        name: 'beheer',
        component: Login
    },
    {
        path: '/diensten',
        component: Dientsten,
        children: [
            {
                path: 'sportmassage',
                name: 'sportmassage',
                component: SportMassage
            },
            {
                path: 'ontspanningsmassage',
                name: 'ontspanningsmassage',
                component: OntspanningsMassage
            },
            {
                path: 'medical-taping',
                name: 'medicaltaping',
                component: MedicalTaping
            }
        ]
    },
    {
        path: '/over-mij',
        name: 'overmij',
        component: OverMij
    },
    {
        path: '/tarieven',
        name: 'tarieven',
        component: Tarieven
    },
    {
        path: '/nieuws',
        name: 'nieuws',
        component: Nieuws
    },
    {
        path: '/contact',
        name: 'contact',
        component: Contact
    },
    {
        path: '/uitloggen',
        name: 'logout',
        component: Logout
    },
    {
        path: '/404',
        name: 'notfound',
        component: NotFound
    }
]